import { IModelJsonValues } from '@sparelabs/http-client-utils'

export enum RiderAppAccountListItem {
  MyTrips = 'MyTrips',
  Payments = 'Payments',
  Organization = 'Organization',
  Settings = 'Settings',
  Announcements = 'Announcements',
  RiderGuide = 'RiderGuide',
  FAQ = 'FAQ',
  FeedbackMetro = 'FeedbackMetro',
  Legal = 'Legal',

  // Settings Screen
  SettingsFavorites = 'SettingsFavorites',
  SettingsGroupMemberships = 'SettingsGroupMemberships',
  SettingsFleetAgreements = 'SettingsFleetAgreements',
  SettingsNotificationChannel = 'SettingsNotificationChannel',
  SettingsCases = 'SettingsCases',
  SettingsDefaultTripPreferenceRiders = 'SettingsDefaultTripPreferenceRiders',
  SettingsDefaultTripPreferenceA11yFeatures = 'SettingsDefaultTripPreferenceA11yFeatures',
}

export enum HomeScreenTripMode {
  ScheduledAndLeaveNow = 'scheduledAndLeaveNow',
  ScheduledOnly = 'scheduledOnly',
  LeaveNowOnly = 'leaveNowOnly',
}

export interface IOrganizationRiderAppSettingsResponse extends IModelJsonValues {
  restrictAccountCreationToAdminsOnly: boolean
  accountListBlacklist?: RiderAppAccountListItem[] | null
  homeScreenTripMode: HomeScreenTripMode
}

export interface IOrganizationRiderAppSettingsPatchBody {
  restrictAccountCreationToAdminsOnly?: boolean
  accountListBlacklist?: RiderAppAccountListItem[]
  homeScreenTripMode?: HomeScreenTripMode
}
